import React from 'react';
import classNames from 'classnames';
import './MenuButton.css';

import { store } from '../Store';
import { observer } from 'mobx-react-lite';

const MenuButton = observer((props) => {
  const handleClick = () => {
    store.setMenuOpen(!store.menuOpen);
  }

  return (
    <button 
      className={ classNames('menu-button', { 'visible' : props.visible, 'close': store.menuOpen }) }
      onClick={handleClick}
    >
      <div className='bar bar1'></div>
      <div className='bar bar2'></div>
      <div className='bar bar3'></div>
    </button>
  )
});

export { MenuButton };